import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

export type UnNaNumberOption = {
  name: string;
  sequence: number;
  class: string;
  id: string;
  label: string;
  packingGroup: string;
};

export type PaginatedResponse<T> = {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type UnNaNumbersSearchParams = {
  search: string;
  page: number;
  limit: number;
};

export const getUnNaNumbersAPI = async (
  params: UnNaNumbersSearchParams
): Promise<PaginatedResponse<UnNaNumberOption>> => {
  try {
    const response = await axios.get<PaginatedResponse<UnNaNumberOption>>(
      getUrl(ApiType.UN_NA_NUMBERS),
      { params }
    );
    return response.data;
  } catch (error) {
    return throwApiError(error, ErrorMessages.unNaNumbersMaster, {
      badRequestOrder: "errorsFirst",
    });
  }
};
